import get from 'lodash/get';
import { hasPairAuthFlowParam } from '../../../utils/auth/pairAuthFlowHelpers';

export function getOauthPartnerId(location) {
  return get(location, 'query.client_id') || get(location, 'query.partnerid');
}

// NOTE:
// The getPartnerParams helper is specifically for SI && SU auth requests
// However, if a user is in the pairing flow, their partnerID & serial will represent the device being paired
// even though the auth request will come from mobile web
// On failed attempts, this was confusing platform && causing recaptcha issues
// To solve, when in pairing flow, we can avoid sending partnerId & serial in the auth requests
export default function getPartnerParams(isPartner, location) {
  if (!isPartner || hasPairAuthFlowParam(location?.query)) return {};

  return {
    partnerId: getOauthPartnerId(location),
    serial: get(location, 'query.serial'),
  };
}
